var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { withPortal } from "../../hoc/withPortal";
import ActionMenu from "./ActionMenu";
import { StyledContextActionMenu, StyledContextTarget, StyledContextMenuErrorMessage } from "./ContextActionMenu.style";
import { MenuError } from "./KebabActionMenu";
import { useAsyncActionMenu } from "./useAsyncActions";
export const ContextMenuErrorMessage = () => (React.createElement(StyledContextMenuErrorMessage, null,
    React.createElement(MenuError, null)));
const PortalContent = (_a) => {
    var { isVisible, hide, id, "data-insights": insightsAttr, actions, update } = _a, rest = __rest(_a, ["isVisible", "hide", "id", "data-insights", "actions", "update"]);
    const { asyncActions, isError } = useAsyncActionMenu(isVisible, actions, update);
    if (isError) {
        return React.createElement(ContextMenuErrorMessage, null);
    }
    if (asyncActions && Array.isArray(asyncActions) && asyncActions.length > 0) {
        return (React.createElement(StyledContextActionMenu, null,
            React.createElement(ActionMenu, Object.assign({ "aria-label": "context-menu", id: id, "data-insights": insightsAttr, onSelect: () => {
                    hide(1);
                } }, rest), asyncActions)));
    }
    return null;
};
const Target = ({ children, forwardedRef, onContextMenu }) => (React.createElement(StyledContextTarget, { ref: forwardedRef, onContextMenu, children }));
const ContextActionMenuWithPortal = withPortal(PortalContent, { trigger: "right-click" })(Target);
const ContextActionMenu = (_a) => {
    var { actions, children } = _a, rest = __rest(_a, ["actions", "children"]);
    return actions ? React.createElement(ContextActionMenuWithPortal, Object.assign({ actions, children }, rest)) : React.createElement(React.Fragment, null, children);
};
export const withContextMenu = (CustomTarget) => {
    const TargetWithPortal = useMemo(() => {
        return withPortal(PortalContent, { trigger: "right-click" })(CustomTarget);
    }, [CustomTarget]);
    const WithContextMaybe = useMemo(() => function WithContextMaybe(_a) {
        var { actions } = _a, rest = __rest(_a, ["actions"]);
        return actions ? (React.createElement(TargetWithPortal, Object.assign({ actions }, rest))) : (React.createElement(React.Fragment, null, "children" in rest ? rest["children"] : null));
    }, [TargetWithPortal]);
    return WithContextMaybe;
};
export default ContextActionMenu;
//# sourceMappingURL=ContextActionMenu.js.map